import { ContinueButton } from "./components/continue-btn/continue-btn";
import isabellaWhite from "./images/experts/isabella-white.webp";
import josephRodriguez from "./images/experts/joseph-rodriguez.webp";
import masonBrown from "./images/experts/mason-brown.webp";
import robertJones from "./images/experts/robert-jones.webp";
import sophiaAnderson from "./images/experts/sophia-anderson.webp";
import thomasMartinez from "./images/experts/thomas-martinez.webp";
import williamJohnson from "./images/experts/william-johnson.webp";

const answers = [
  "Welcome! Tell me about your question. I’ll match you with the best-fit advisor.",
  "To provide insights on your natal chart, could you please share your date and place of birth?",
  "Could you please provide your time of birth, if known? This will help create a more detailed natal chart.",
  ["OK. Got it. I’m sending you to a secure page to join ….. for only $ (fully-refundable). While you’re filling out that form, I’ll tell the relevant advisor about your situation and then connect you two. They will give you as much useful information as possible to answer your question. ",  <ContinueButton/>],
];

const experts = [
  {
    name: "Isabella White",
    avatar: isabellaWhite,
  },
  {
    name: "Joseph Rodriguez",
    avatar: josephRodriguez,
  },
  {
    name: "Mason Brown",
    avatar: masonBrown,
  },
  {
    name: "Robert Jones",
    avatar: robertJones,
  },
  {
    name: "Sophia Anderson",
    avatar: sophiaAnderson,
  },
  {
    name: "Thomas Martinez",
    avatar: thomasMartinez,
  },
  {
    name: "William Johnson",
    avatar: williamJohnson,
  },
];

export { answers, experts };
